import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * page / searchText / language 를 URL 기준으로 관리
 * startup, patent 공용
 */
export default function useSearch(options = {}, tabName = "") {
    const {
        minSearchLength = 2,
        defaultLanguage = "ko",
    } = options;

    const [searchParams, setSearchParams] = useSearchParams();

    const page = Number(searchParams.get("page")) || 1;
    const searchText = searchParams.get("searchText") || "";
    const language = searchParams.get("language") || defaultLanguage;

    const isSearchable =
        searchText.length === 0 || searchText.length >= minSearchLength;

    /**
     * URL 파라미터 갱신
     */
    const updateParams = ({ page: p, searchText: s, language: l }) => {
        setSearchParams(
        {
            page: String(p ?? page),
            searchText: s ?? searchText,
            language: l ?? language,
        },
        { replace: true }
        );
    };

    
    useEffect(() => {
        const savedLanguage = sessionStorage.getItem(`${tabName}:lastLanguage`);

        if (savedLanguage && savedLanguage !== language) {
            updateParams({ language: savedLanguage });
            sessionStorage.removeItem(`${tabName}:lastLanguage`);
        }
    }, []);

    return {
        page,
        searchText,
        language,
        isSearchable,
        updateParams,
    };
}
